import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}api`;

const api = axios.create({
  baseURL: API,
  headers: { 'Content-Type': 'application/json' },
});

// Leads
export const leadsApi = {
  list: () => api.get('/leads').then(r => r.data),
  create: (data) => api.post('/leads', data).then(r => r.data),
  update: (id, data) => api.patch(`/leads/${id}`, data).then(r => r.data),
  remove: (id) => api.delete(`/leads/${id}`).then(r => r.data),
};

// Tasks
export const tasksApi = {
  list: () => api.get('/tasks').then(r => r.data),
  create: (data) => api.post('/tasks', data).then(r => r.data),
  update: (id, data) => api.patch(`/tasks/${id}`, data).then(r => r.data),
  remove: (id) => api.delete(`/tasks/${id}`).then(r => r.data),
};

// Contacts
export const contactsApi = {
  list: () => api.get('/contacts').then(r => r.data),
  create: (data) => api.post('/contacts', data).then(r => r.data),
  update: (id, data) => api.patch(`/contacts/${id}`, data).then(r => r.data),
  remove: (id) => api.delete(`/contacts/${id}`).then(r => r.data),
};

// Invoices
export const invoicesApi = {
  list: () => api.get('/invoices').then(r => r.data),
  create: (data) => api.post('/invoices', data).then(r => r.data),
  update: (id, data) => api.patch(`/invoices/${id}`, data).then(r => r.data),
  remove: (id) => api.delete(`/invoices/${id}`).then(r => r.data),
};

// Quotations
export const quotationsApi = {
  list: () => api.get('/quotations').then(r => r.data),
  create: (data) => api.post('/quotations', data).then(r => r.data),
  update: (id, data) => api.patch(`/quotations/${id}`, data).then(r => r.data),
  remove: (id) => api.delete(`/quotations/${id}`).then(r => r.data),
};

export default api;
